import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InstallCard } from 'components';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';
import copy from 'copy-to-clipboard';
import './pixel.scss';
class Pixel extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  //on click copy btn copy the script
  copyWallScript = (script) => {
    copy('<!-- Widget BEGIN -->' + script + '<!-- Widget END -->', { debug: true });

    let toastDiv = document.getElementById('copy-pixel');
    toastDiv.className = 'copy-script-upbg click-to-copy';

    setTimeout(() => {
      toastDiv.className = 'copy-script-upbg';
    }, 5000);

    if (!toast.isActive(this.toastId)) {
      this.toastId = toast.success('Your pixel code is copied.');
    }
    return;
  }

  render() {
    return (
      <div className="pixel-container main-container">
        <InstallCard
          copyWallScript={this.copyWallScript} />
      </div>
    );
  }
}

// const mapStateToProps = () => {

// };

// const mapDispatchToProps = {

// };

// export default connect(mapStateToProps, mapDispatchToProps, { withRef: true })(Pixel);
export default connect()(Pixel);


// WEBPACK FOOTER //
// ./src/containers/Pixel/pixel.js